import PropTypes from 'prop-types';
import TravelWitsLogo from '../../assets/svgs/travelwitsLogo.svg';

const TwPoweredByLogo = ({ doMakeSmaller }) => (
  <div className="flex flex-col items-start ml-auto mt-2">
    <div className={`${doMakeSmaller ? 'text-10' : 'text-xs'} text-black`}>Powered by</div>
    {/* oxlint-disable-next-line nextjs/no-html-link-for-pages */}
    <a href="/">
      <TravelWitsLogo
        fill="black"
        width={doMakeSmaller ? '90' : '130'}
        height={doMakeSmaller ? '15' : '20'}
      />
    </a>
  </div>
);

TwPoweredByLogo.propTypes = {
  doMakeSmaller: PropTypes.bool,
};

TwPoweredByLogo.defaultProps = {
  doMakeSmaller: false,
};

export default TwPoweredByLogo;
